import e from"./merge.js";function r(...r){const o=r.reduce(((e,r)=>(r.filterProps.forEach((o=>{e[o]=r})),e)),{}),t=r=>Object.keys(r).reduce(((t,c)=>o[c]?e(t,o[c](r)):t),{});return t.propTypes={},t.filterProps=r.reduce(((e,r)=>e.concat(r.filterProps)),[]),t}export{r as default};
//# sourceMappingURL=compose.js.map
